<div id="drag-drop-lists">
  <h2>{{ field.key + '-selectable-fields' | translate }}</h2>
  <h2>{{ field.key + '-selected-fields' | translate }}</h2>
  <div id="lists">
    <div class="drag-drop-container selectableFields">
      <div cdkDropList
           [id]="field.key + '_selectableFieldsList'"
           [cdkDropListData]="dndList.selectableFields"
           [cdkDropListConnectedTo]="field.key + '_selectedFieldsList'"
           (cdkDropListDropped)="drop($event)"
           class="list small">
        <div *ngFor="let item of dndList.selectableFields"
             class="field"
             cdkDrag
             [cdkDragData]="item">
          {{ item.text | translate }}
        </div>
      </div>
    </div>
    <div class="drag-drop-container selectedFields">
      <div cdkDropList
           [id]="field.key + '_selectedFieldsList'"
           [cdkDropListData]="dndList.selectedFields"
           [cdkDropListConnectedTo]="field.key + '_selectableFieldsList'"
           (cdkDropListDropped)="drop($event)"
           class="list small">
        <div *ngFor="let item of dndList.selectedFields; index as i"
             class="field"
             cdkDrag
             [cdkDragData]="item">
          {{ item.text | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
